// TODO: Gate behind cookie consent before launching to EU/UK users (GDPR / ePrivacy:
// sessionStorage + server-minted UUID is still a first-party persistent identifier for analytics).
import TokenService from "./token.service";
import { UsePlatformApi } from "./api.service";

let keepAliveTimer = null;

const cancelKeepAlive = () => {
    if (keepAliveTimer) {
        clearTimeout(keepAliveTimer);
        keepAliveTimer = null;
    }
};

const setCoursewareEmbedMode = () => {
    cancelKeepAlive();
    TokenService.setSessionId(null);
};

export default function useAnalyticsService() {
    const platformClient = UsePlatformApi();

    const pingSession = async () => {
        try {
            const session_id = TokenService.getSessionId() || null;
            const { data } = await platformClient.post("/analytics/ping/", { session_id });
            if (data?.session_id) TokenService.setSessionId(data.session_id);
            if (data?.ping_interval_seconds) {
                cancelKeepAlive();
                keepAliveTimer = setTimeout(pingSession, data.ping_interval_seconds * 1000);
            }
        } catch {
            // never break the app for analytics
        }
    };

    return {
        pingSession,
        setCoursewareEmbedMode,
    };
}
